<template>
  <div class="plan">
    <progressBar
      class="plan-progress"
      :arr="progressData"
      :activeIndex="progressActiveIndex"></progressBar>
    <tips class="plan-tip">
      <div class="plan-tip__line"> 1. 当在“销售/发补货管理”或“销售/产品储备管理”目录里“新建FBA发补货计划”或“新建产品储备计划”时，系统将在“采购/产品采购管理”目录内同时自动生成对应的“采购计划单”；因此如要删除“采购计划单”需先到“销售”目录内删除对应项； </div>
      <div class="plan-tip__line"> 2.“采购计划单”是“采购单”的过渡，"采购计划单”里的每款产品都将被拆分成“子采购计划单”，两个或以上的子采购计划单如果同属一个供应商，点击“生成采购单"后将可以进行合并生成一个"待补充采购单"，"待补充采购单"补充完成后将自动生成"采购单"! </div>
      <div class="plan-tip__line"> 3. 采购计划分为“FBA发补货计划”及“商品储备计划”两类；由于现实场景下操作复杂,暂时不向“商品储备计划单”提供“FBA发补货计划单”一样的拆分合并生成采购单功能；因此,用户可通过点击“商品储备计划单”右侧的“独立采购”直接生成采购单； </div>
    </tips>
    <div class="plan-top">
      <div class="plan-top__name">采购计划单</div>
      <div class="plan-top__fun">
        <div class="plan-top-item plan-top-item--date">
          <div class="plan-top-item__name">创建日期:</div>
          <el-date-picker
            size="mini"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"></el-date-picker>
        </div>
        <div class="plan-top-item plan-top-item--date">
          <div class="plan-top-item__name">要求交货日期:</div>
          <el-date-picker
            size="mini"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"></el-date-picker>
        </div>
        <div class="plan-top-item">
          <div class="plan-top-item__name">采购计划分类:</div>
          <el-select size="mini"></el-select>
        </div>
        <div class="plan-top-item">
          <div class="plan-top-item__name">状态:</div>
          <el-select size="mini"></el-select>
        </div>
        <div class="plan-top-item plan-top-item--input">
          <el-input size="mini" placeholder="请输入采购计划单号"></el-input>
        </div>
        <div class="plan-top__btn">搜索</div>
        <div class="plan-top__btn" @click="newProductReservesBtnClick">待生成采购计划单</div>
      </div>
    </div>
    <div class="plan-table">
      <Table height="550" width="1654" :head="planTableHead"></Table>
    </div>
  </div>
</template>

<script>
import { PurchaseNewModule } from './class'
import progressBar from 'components/common/progressBar';
import Table from 'components/common/Table.vue'
import tips from '../common/tips.vue';
export default {
  name: 'purchasePlanSheet',
  components: {
    progressBar, tips, Table
  },
  data(){
    return {
      /**进度条数据 */
      progressData: PurchaseNewModule.NEWPROGRESSARRAY(),
      progressActiveIndex: 1,
      planTableHead: PurchaseNewModule.NEWPLANTABLEHEAD()
    }
  }
}
</script>

<style lang="scss" scoped>
.plan{
  width: 1800px;
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    &__name{
      font-weight: bold;
      font-size: 16px;
      color: black;
    }
    &__fun{
      display: flex;
    }
    &-item{
      display: flex;
      align-items: center;
      margin-left: 10px;
      ::v-deep{
        .el-input__inner{
          width: 100px;
        }
      }
      &__name{
        font-size: 14px;
        margin-right: 5px;
      }
      &--date{
        ::v-deep{
          .el-input__inner{
            width: 180px;
          }
        }
      }
      &--input{
        ::v-deep{
          .el-input__inner{
            width: 180px;
          }
        }
      }
    }
    &__btn{
      line-height: 30px;
      padding: 0 15px;
      color: white;
      background: #00a0c7;
      margin-left: 10px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
}
</style>
